(function () {
    'use strict';
    var m = angular.module('policy');
    m.directive('policyTable', ["$q", "tablePaginationHelper", "routeHelper", "$routeParams", "path", "policyDao", "objectTypeDao", "columnsHelper", "$timeout", "widgetSettings", "workingIndicatorHelper", "policySeverityTypes", "policyScheduledExportModal", "sideMenuManager", "$route", "troubleshooting", "modals", "policyActions", "remediationProperties", "policyPropertiesFilter", "rolesManager", "$rootScope", "policiesRefreshHelper", function ($q, tablePaginationHelper, routeHelper, $routeParams, path, policyDao, objectTypeDao, columnsHelper, $timeout, widgetSettings, workingIndicatorHelper, policySeverityTypes, policyScheduledExportModal, sideMenuManager, $route, troubleshooting, modals, policyActions, remediationProperties, policyPropertiesFilter, rolesManager, $rootScope, policiesRefreshHelper) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('policy').directive('policy-table').template(),
            scope: { createPage: '=' },
            link: function ($scope, element, attr) {
                $scope.tableModel = false;
                workingIndicatorHelper.init($scope);
                function changeStatus(policyIds, status) {
                    policyDao.changeBatchStatus(policyIds, status).then(function () {
                        $scope.tableHelper.clearSelection();
                        $scope.tableHelper.reload();
                    });
                }
                function isActionActive(state, singleSelection) {
                    return function () {
                        var selected = $scope.tableHelper.getSelected();
                        var idx = columnsHelper.getIdxById($scope.options.columns, 'policy_data.actions');
                        var isUnauthorized = _(selected).some(function (s) {
                            // check if policy has actions
                            if (s[idx].originalText.length) {
                                // if policy has actions, check if the user is not one of the following roles
                                if (!rolesManager.isActionAllowed([
                                        'admin',
                                        'user'
                                    ])) {
                                    return true;
                                }
                            }
                        });
                        if (isUnauthorized) {
                            return false;
                        }
                        if (singleSelection && selected.length > 1 || selected.length === 0) {
                            return false;
                        }
                        if (_(state).isUndefined()) {
                            return true;
                        }
                        idx = columnsHelper.getIdxById($scope.options.columns, 'policy_status');
                        return _(selected).some(function (s) {
                            return s[idx].originalText !== state;
                        });
                    };
                }
                var allSystemHidden = $route.current.hideSystemPolicies;
                if ($scope.createPage) {
                    allSystemHidden = true;
                }
                var policyListWidgetUUID = '523cd709-a4b5-4857-bfa0-06b280b0686e';
                var showPausedPoliciesKey = 'show-paused-policies';
                var showHiddenPoliciesKey = 'show-hidden-policies';
                var showTemporaryPoliciesKey = 'show-temporary-policies';
                $timeout(function () {
                    $scope.$apply(function () {
                        $scope.policyListPanel = {
                            uuid: policyListWidgetUUID,
                            wrapper: {
                                title: $scope.createPage ? 'My Queries' : 'Queries',
                                'class': 'light white-body white-header',
                                filters: [
                                    {
                                        type: 'flag',
                                        local: true,
                                        state: false,
                                        text: 'Show paused queries',
                                        value: showPausedPoliciesKey
                                    },
                                    {
                                        type: 'flag',
                                        local: true,
                                        state: false,
                                        text: 'Show temporary queries',
                                        value: showTemporaryPoliciesKey
                                    }
                                ]
                            }
                        };
                    });
                });
                if (!allSystemHidden || troubleshooting.entityDebugEnabled()) {
                    $timeout(function () {
                        $scope.$apply(function () {
                            $scope.policyListPanel.wrapper.filters.splice(1, 0, {
                                type: 'flag',
                                local: true,
                                state: false,
                                text: 'Show system queries',
                                value: showHiddenPoliciesKey
                            });
                        });
                    });
                }
                $scope.tableOptions = {
                    pagesAround: 2,
                    pageSize: 20,
                    pagination: {
                        page: 1,
                        ordering: {},
                        filter: ''
                    },
                    saveState: false,
                    disableTop: true,
                    showWorkingIndicator: true,
                    dropdownHeader: true,
                    headerOptions: { enum: { multiple: true } },
                    saveOptionalColumnsUUID: policyListWidgetUUID,
                    actions: [],
                    filter: function (row) {
                        var idx = columnsHelper.getIdxById($scope.options.columns, 'policy_status');
                        return row[idx].originalText !== 'mark_for_deletion';
                    }
                };
                if (rolesManager.isActionAllowed([
                        'admin',
                        'user'
                    ])) {
                    $scope.tableOptions.actions = [
                        {
                            label: 'Pause',
                            active: isActionActive('pause'),
                            execute: function () {
                                changeStatus($scope.tableHelper.getSelectedIds(), 'pause');
                            }
                        },
                        {
                            label: 'Start',
                            active: isActionActive('running'),
                            execute: function () {
                                changeStatus($scope.tableHelper.getSelectedIds(), 'running');
                            }
                        },
                        {
                            label: 'Delete',
                            active: isActionActive(),
                            execute: function () {
                                changeStatus($scope.tableHelper.getSelectedIds(), 'mark_for_deletion');
                            }
                        },
                        {
                            label: 'Export',
                            active: isActionActive(),
                            execute: function () {
                                $q.all(_($scope.tableHelper.getSelectedIds()).map(function (policyId) {
                                    return policyDao.retrieve(policyId);
                                })).then(function (responses) {
                                    var policies = _(responses).map(function (response) {
                                        var policy = response.data;
                                        delete policy.policy_id;
                                        return policy;
                                    });
                                    var blob = new Blob([JSON.stringify(policies)], { type: 'application/json;charset=utf-8' });
                                    var name = 'policies_export';
                                    if (policies.length == 1) {
                                        name = _(policies).first().policy_name;
                                    }
                                    saveAs(blob, name + '.json');
                                });
                            }
                        },
                        {
                            label: 'Add new query',
                            display: 'button',
                            execute: function () {
                                routeHelper.redirectTo('policy-create');
                            }
                        },
                        {
                            label: 'Import a query',
                            display: 'button',
                            execute: function () {
                                $timeout(function () {
                                    $('#import-file').trigger('click');
                                });
                            }
                        }
                    ];
                }
                if ($scope.createPage) {
                    $scope.tableOptions.actions = [];
                }
                $scope.createHref = routeHelper.getHref('policy-create');
                $scope.importFileReadComplete = function (content) {
                    try {
                        var policies = JSON.parse(content);
                        if (!_(policies).isArray()) {
                            policies = [policies];
                        }
                        $q.all(_(policies).map(function (policy) {
                            return policyDao.create(policy);
                        })).then(function (responses) {
                            if (responses.length == 1) {
                                routeHelper.redirectTo('policy-edit', { id: _(responses).first().data.policy_id });
                            } else {
                                $scope.tableHelper.reload();
                            }
                        });
                    } catch (e) {
                        alert('Incorrect file');
                    }
                };
                $scope.$watchCollection(function () {
                    return [
                        widgetSettings.param(policyListWidgetUUID, showPausedPoliciesKey),
                        widgetSettings.param(policyListWidgetUUID, showHiddenPoliciesKey),
                        widgetSettings.param(policyListWidgetUUID, showTemporaryPoliciesKey)
                    ];
                }, function (newVal, oldVal) {
                    if (newVal != oldVal && !_($scope.tableHelper).isUndefined()) {
                        $scope.tableHelper.clearSelection();
                        $scope.tableHelper.reload();
                    }
                });
                $q.all([
                    path('policy').ctrl('policy-list').jsonRel('list-conf').retrieve(),
                    objectTypeDao.retrieve(undefined, true),
                    policyDao.listFacets()
                ]).then(function (responses) {
                    $scope.options = responses[0].data;
                    $scope.sources = responses[1].data.sources;
                    $scope.sourcesInfo = responses[1].data.sourcesInfo;
                    $scope.saasList = responses[1].data.saasList;
                    $scope.facets = responses[2].data;
                    $scope.actionLabels = {};
                    _(responses[1].data.actionTypes).each(function (arr) {
                        _(arr).each(function (action) {
                            $scope.actionLabels[action.id] = action.label;
                        });
                    });
                    function setVariants(columnId, variants) {
                        _($scope.options.columns).find(function (column) {
                            return column.id == columnId;
                        }).property = { variants: variants };
                    }
                    setVariants('severity', policySeverityTypes.asVariants());
                    setVariants('context.saas', _($scope.saasList).map(function (saas, id) {
                        return {
                            id: id,
                            label: saas.label
                        };
                    }));
                    setVariants('tags', _($scope.facets.tags).map(function (tag) {
                        return {
                            id: tag,
                            label: tag
                        };
                    }));
                    setVariants('sec_apps', _($scope.facets.sec_apps).map(function (sec_app) {
                        return {
                            id: sec_app,
                            label: sec_app
                        };
                    }));
                    setVariants('policy_data.actions', _($scope.facets.actions).map(function (action) {
                        return {
                            id: action,
                            label: $scope.actionLabels[action]
                        };
                    }));
                    setVariants('entity_type', _($scope.sourcesInfo).chain().map(function (entity, id) {
                        var saasLabel = 'Unknown Saas';
                        if ($scope.saasList[entity.saas]) {
                            saasLabel = $scope.saasList[entity.saas].label;
                        }
                        return {
                            id: id,
                            label: saasLabel + ' - ' + entity.label
                        };
                    }).sortBy('label').value());
                    $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                        var filterParams = _(args.columnsFilters).chain().map(function (value, name) {
                            var first = _(value).first();
                            if (first.type == 'text' && first.operator == 'contains') {
                                return [
                                    name,
                                    first.data
                                ];
                            }
                            if (first.type == 'enum' && first.operator == 'is') {
                                return [
                                    name,
                                    _(value).map(function (v) {
                                        return v.data;
                                    }).join(',')
                                ];
                            }
                            if (first.type === 'boolean' && first.operator === 'is') {
                                return [
                                    name,
                                    first.data
                                ];
                            }
                            return null;
                        }).compact().object().value();
                        var resultTags = '';
                        if (filterParams.filterBy_tags) {
                            resultTags += filterParams.filterBy_tags;
                        }
                        if (filterParams.filterBy_tags && $routeParams.tags) {
                            resultTags += ',';
                        }
                        if ($routeParams.tags) {
                            resultTags += $routeParams.tags;
                        }
                        filterParams.filterBy_tags = resultTags;
                        filterParams.filterBY_not_tags = $routeParams.not_tags;
                        var showPaused = widgetSettings.param(policyListWidgetUUID, showPausedPoliciesKey);
                        var showHidden = widgetSettings.param(policyListWidgetUUID, showHiddenPoliciesKey);
                        var showTemporary = widgetSettings.param(policyListWidgetUUID, showTemporaryPoliciesKey);
                        if (args.filter) {
                            filterParams.keywords = _(args.filter.split(/\s+/)).filter(function (keyword) {
                                return keyword;
                            }).join(',');
                        }
                        if (allSystemHidden) {
                            $scope.noFiltersSet = _(filterParams).chain().find(function (filter) {
                                return filter;
                            }).isUndefined().value();
                            if (!troubleshooting.entityDebugEnabled()) {
                                showHidden = false;
                                filterParams.hide_system = true;
                            } else {
                                if (!showHidden) {
                                    filterParams.hide_system = true;
                                }
                            }
                        }
                        return policyDao.list($scope.options.columns, $scope.sourcesInfo, $scope.actionLabels, !showPaused, !showHidden, !showTemporary).params(filterParams).pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order);
                    }, function (tableModel) {
                        $timeout(function () {
                            $scope.$apply(function () {
                                $scope.tableModel = tableModel;
                                $scope.totalCount = $scope.tableHelper.getTotal();
                                if ($scope.createPage && $scope.tableModel) {
                                    $scope.tableModel.options.checkboxes = false;
                                    $scope.tableModel.options.functionOnClick = choosePolicyAction;
                                    delete $scope.tableOptions.pagination.filter;
                                    $scope.tableOptions.dropdownHeader = false;
                                    var columnScheduled = columnsHelper.getIdxById($scope.tableModel.columns, 'schedule');
                                    angular.forEach($scope.tableModel.data, function (row) {
                                        row[columnScheduled].text = row[columnScheduled].originalText;
                                    });
                                }
                                var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                                if ($scope.tableModel && $scope.tableModel.data) {
                                    var policyIds = _($scope.tableModel.data).chain().map(function (row) {
                                        return row[primaryColumn].originalText;
                                    }).value();
                                    if (policyIds && policyIds.length) {
                                        policiesRefreshHelper.triggerRefreshPolicies(policyIds);
                                    }
                                }
                            });
                        });
                    });
                    function choosePolicyAction(line) {
                        var query = {
                            queryId: line[columnsHelper.getIdxById($scope.tableModel.columns, 'policy_id')].originalText,
                            queryType: line[columnsHelper.getIdxById($scope.tableModel.columns, 'entity_type')].originalText,
                            queryName: line[columnsHelper.getIdxById($scope.tableModel.columns, 'policy_name')].originalText
                        };
                        if ($scope.lastId === query.queryId) {
                            openActionModal(query);
                        } else {
                            policyActions.getActions(query.queryId).then(function (responses) {
                                $scope.lastId = query.queryId;
                                $scope.model = {
                                    includeCondition: {},
                                    excludeCondition: {},
                                    actions: [],
                                    columnsToShow: {},
                                    columnsOrderOverride: null,
                                    columnNames: {}
                                };
                                $scope.internalModel = {
                                    saasList: {},
                                    properties: {},
                                    conditionProperties: {},
                                    excludeByProperties: {},
                                    sources: {},
                                    propertyTypes: {},
                                    actionTypes: {},
                                    columnsList: {}
                                };
                                var properties = responses[0].data;
                                $scope.internalModel.saasList = properties.saasList;
                                $scope.internalModel.sources = properties.sources;
                                $scope.internalModel.allSources = properties.allSources;
                                $scope.internalModel.propertyTypes = properties.propertyTypes;
                                $scope.internalModel.actionTypes = _(properties.actionTypes).chain().map(function (actions, actionTypeName) {
                                    return [
                                        actionTypeName,
                                        _(actions).filter(function (action) {
                                            return !action.exclude_from_policy;
                                        })
                                    ];
                                }).object().value();
                                $scope.internalModel.dataUrls = properties.dataUrls;
                                var policy = responses[1].data.policy_data;
                                $scope.internalModel.oldPolicy = responses[1].data.old_policy_data;
                                $scope.internalModel.scheduled = responses[1].data.scheduled;
                                $.extend(true, $scope.model, policy);
                                $scope.model.saas = responses[1].data.context.saas;
                                $scope.model.layout = responses[1].data.context.layout || {
                                    id: 'info',
                                    leftChart: {
                                        graph: 'bar',
                                        top: 10
                                    },
                                    rightChart: {
                                        graph: 'bar',
                                        top: 10
                                    }
                                };
                                $scope.internalModel.policy_status = responses[1].data.policy_status;
                                $scope.internalModel.temporary = responses[1].data.temporary;
                                $scope.internalModel.system = responses[1].data.system;
                                var sourceProperties = $scope.internalModel.sources(query.queryType);
                                $scope.internalModel.conditionProperties = policyPropertiesFilter(sourceProperties, 'showInCondition');
                                $scope.querySaas = responses[1].data.context.saas;
                                openActionModal(query);
                            });
                        }
                    }
                    function openActionModal(query) {
                        modals.params([{
                                params: [
                                    {
                                        type: 'message',
                                        message: 'Please select an action to run on every item matching "' + query.queryName + '"',
                                        paramClass: 'full-width-param'
                                    },
                                    {
                                        id: 'action',
                                        type: 'selector',
                                        label: '',
                                        data: 'Select action',
                                        variants: $scope.internalModel.actionTypes[query.queryType],
                                        paramClass: 'full-width-param',
                                        validation: { required: true }
                                    }
                                ],
                                lastPage: true
                            }], 'Select action', 'md').then(function (data) {
                            var actionType = $scope.internalModel.actionTypes[query.queryType].find(function (x) {
                                return x.id === data.action;
                            });
                            if (!actionType) {
                                return modals.alert('Please select one of the listed actions.', {
                                    title: 'Error',
                                    keyboard: false,
                                    backdrop: 'static',
                                    disableCloseX: true
                                }).then(function () {
                                    openActionModal(query);
                                });
                            }
                            var action = policyActions.addAction(actionType, $scope.model, $scope.internalModel);
                            policyActions.showConfigurePopup(action, $scope.model, $scope.internalModel).then(function (configuredAction) {
                                $scope.model.actions.push(configuredAction);
                                return policyActions.updatePolicy(query.queryId, $scope.model, $scope.internalModel).then(function () {
                                    routeHelper.redirectTo('policy-rules', { saasActive: $scope.querySaas });
                                });
                            }, function () {
                                openActionModal(query);
                            });
                        });
                    }
                    $scope.$on('edit-scheduled-export', function (event, data) {
                        var policyId = data.policyId;
                        policyDao.retrieve(policyId).then(function (response) {
                            var policy = response.data;
                            policyScheduledExportModal(policy.scheduled).then(function (data) {
                                policy.scheduled = data;
                                policyDao.update(policyId, policy).then(function () {
                                    $scope.tableHelper.reload();
                                });
                            });
                        });
                    });
                    $scope.$on('remove-scheduled-export', function (event, data) {
                        var policyId = data.policyId;
                        policyDao.retrieve(policyId).then(function (response) {
                            var policy = response.data;
                            policy.scheduled = { frequency: 'none' };
                            policyDao.update(policyId, policy).then(function () {
                                $scope.tableHelper.reload();
                            });
                        });
                    });
                    $scope.$on('do-refresh-policy-list-page', function (event, data) {
                        var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                        if ($scope.tableModel && $scope.tableModel.data) {
                            var policyIds = _($scope.tableModel.data).chain().map(function (row) {
                                return row[primaryColumn].originalText;
                            }).value();
                            if (policyIds && policyIds.length) {
                                return policiesRefreshHelper.triggerRefreshPolicies(policyIds).then(function () {
                                    $scope.tableHelper.reload();
                                    $rootScope.$broadcast('done-refresh-policy-list-page');
                                });
                            }
                        }
                        $rootScope.$broadcast('done-refresh-policy-list-page');
                    });
                });
                if ($routeParams.tags && !$routeParams.not_tags) {
                    sideMenuManager.treeNavigationPath([
                        'analytics',
                        _($routeParams.tags.split(',')).first()
                    ]);
                } else if (!$routeParams.tags && $routeParams.not_tags) {
                    sideMenuManager.treeNavigationPath([
                        'analytics',
                        'user'
                    ]);
                } else {
                    sideMenuManager.treeNavigationPath(['analytics']);
                }
            }
        };
    }]);
}());